// extracted by mini-css-extract-plugin
module.exports = {"answer":"answer_answer__H_XZU","text":"answer_text__rCaN5"};